import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import UserBlock from './UserBlock';
import s from './Users.scss';
var Users = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block, headerClassName: s['header'] },
        React.createElement("div", null, (_b = block.users) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
            var user = _a.user, deviations = _a.deviations;
            return user &&
                deviations && (React.createElement(UserBlock, { key: user.userId, parentDeviation: parentDeviation, user: user, deviations: deviations }));
        }))));
};
Users.displayName = 'Users';
export default Users;
//# sourceMappingURL=Users.js.map